module.exports = __webpack_public_path__ + "static/img/姓名.5bf4b64.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/姓名.png
// module id = 297
// module chunks = 382